import {Link, useParams} from "react-router-dom";
import {Image} from "semantic-ui-react";
import React, {useMemo} from "react";
import styled from "styled-components";
import {getHederstegn} from "../../../data/data";
import {device} from "../../../theme";
import {Menu} from "../../layout/Menu";

const hederstegn = getHederstegn();

export const HederstegnPerson = () => {
    const params = useParams();
    const id = params.id;
    const person = useMemo(() => hederstegn.find(h => h.personID === id), [id])
    const distinctionIds = useMemo(() => [...new Set(person.distinctions.map(d => d.id))], [person])
    return <>
        <Header>
            <div>
                <a href="https://nsff.no"><Image src={"/resultater/images/logo-darkgreen.png"} alt="Logo"
                                                 height={"60"}/></a>

            </div>
            <div>
                <div>
                    <Link to={`/`}>
                        {person?.name}
                    </Link>
                </div>
                <div>Plaketter og Hederstegn</div>
            </div>
            <div>
                <Link to={"/hederstegn"}>Tilbake</Link>
            </div>
        </Header>
        <Menu/>
        <Container>
            <section className={"points"}>
                <div className={"div-table"}>
                    <div>
                        <div>ANSFF</div>
                        <div>{person?.ansff}</div>
                    </div>
                    <div>
                        <div>ENSFF</div>
                        <div>{person?.ensff}</div>
                    </div>
                    <div>
                        <div>Nasjonale poeng</div>
                        <div>{person?.nasjonalplakett}</div>
                    </div>
                    <div>
                        <div>Internasjonale poeng</div>
                        <div>{person?.internasjonalplakett}</div>
                    </div>
                </div>
            </section>
            <section className={"hederstegn"}>
                {distinctionIds.map(id => <Distinctions person={person} id={id}/>)}
            </section>
        </Container>
    </>
}

const Distinctions = ({person, id}) => {
    return <DistinctionsStyled key={id}>
        <h1>{person.distinctions.find(d => d.id === id).category}</h1>
        {person.distinctions.filter(d => d.id === id).map(distinction => <Distinction distinction={distinction}/>)}
    </DistinctionsStyled>
}

const Distinction = ({distinction}) => {
    return <Title
        key={distinction.id}
        iconColor={distinction.displaySettings?.iconBackgroundColor}
        backgroundColor={distinction.displaySettings?.backgroundColor}
    >
        <div><Image src={`/resultater/${distinction?.displaySettings?.iconUrl}`}/></div>
        <div>
            <div>{distinction.name}</div>
            <div>Tildelt: {distinction.year}</div>
        </div>
    </Title>

}

const DistinctionsStyled = styled.div`
  margin-top: 20px;
  width: auto;

  @media ${device.mobile} {
    width: 100%;
  }
`


const Title = styled.div`
  width: 400px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  font-family: 'Fibon Neue';
  box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%);
  background-color: ${(p) => p?.backgroundColor ? p.backgroundColor : "#ebf4f3"};
  margin-top: 10px;

  @media ${device.mobile} {
    width: calc(100vw - 40px);
  }

  > div:nth-child(1) {
    background-color: ${(p) => p?.iconColor ? p.iconColor : "#ebf4f3"} !important;
    border-radius: 8px;
    width: 70px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  img {
    width: 50px;
    height: 50px;
  }

  > div:nth-child(2) {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;


    > div:nth-child(1) {
      font-weight: bold;
    }
  }
`

const Container = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  @media ${device.mobile} {
    width: 100%;
  }

  .points {
    font-size: 1.5rem;
    @media ${device.mobile} {
      width: calc(100% - 20px);
    }

    .div-table {
      display: table;
      width: auto;
      border-spacing: 5px;
      border-radius: 8px;
      padding: 10px;
      box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%);

      @media ${device.mobile} {
        width: 100%;
      }

      > div {
        display: table-row;
        width: auto;
        clear: both;

        > div {
          float: left;
          display: table-column;
          width: 250px;
          @media ${device.mobile} {
            width: 75%;
          }
        }

        > div:nth-child(2) {
          width: 100px;
          text-align: right;
          @media ${device.mobile} {
            width: 25%;
          }
        }
      }
    }
  }

  @media (min-width: 500px) {
    .hederstegn {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  @media (min-width: 900px) {
    .hederstegn {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: 1300px) {
    .hederstegn {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .hederstegn {
    max-width: 1300px;
    margin: 0 auto;
    display: grid;
    gap: 2rem;

    @media ${device.mobile} {
      width: 100%;
      max-width: calc(100vw - 40px);
    }
  }
`

const Header = styled.div`
  height: 70px;
  background-color: #90b361;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #36501c;
  font-family: 'Fibon Neue';

  > div {
    display: flex;
    flex-direction: row;
    margin-left: 10px;
    font-weight: bold;
    justify-content: center;

    >div:nth-child(1) {
      font-weight: bold;
    }
    > div {
      font-weight: normal;

      > a {
        color: ${(p) => p.theme.color.primary.base};
      }
    }



    align-items: center;
  }

  > div:nth-child(2) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    font-size: 1.4rem;
  }

  > div:nth-child(3) {
    margin-right: 20px;

    > a {
      color: ${(p) => p.theme.color.primary.base};
    }
  }
`